
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './Components/LayoutComponents/Layout';
import React, { Component } from 'react';
import './App.css';


export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, ...rest } = route;
            return <Route key={index} exact {...rest} element={element} />;
          })}
        </Routes>
      </Layout>
    );
  }
}